import React from 'react';
import autobind from 'autobind-decorator';

import { connect } from 'react-redux';
import { PureComponent, GroupBox } from 'core/components';
import { withLocale } from 'core/decorators';
import { BlockTitle, List, ListItem, Icon, CardContent } from 'core/components/Framework7';
import { logout } from 'core/module/operations';
import { getCart } from 'content/pages/Cart/Module';

import classes from './styles.module.css';

class ViewProfile extends PureComponent {
  constructor(props) {
    super(props)

    this.state = {

    }
  }

  static get defaultProps() {
    return {

    }
  }

  signOut() {
    this.$f7.dialog.confirm("آیا می‌خواهید از حساب کاربری خود خارج شوید؟", "خروج از حساب کاربری", this.confirmLogOut, this.$f7.dialog.close())
  }

  confirmLogOut() {
    this.props.logout()
      .then(r => {
        this.props.getCart({ store: 2 })
      })
  }

  render() {
    const { user, navigate } = this.props;

    return (
      <GroupBox outline
        title={user ? `${user.firstName} ${user.lastName} (${user.mobile})` : ''}
      >
        <CardContent>
          <List>
            <ListItem
              href="/profile/edit"
              title="ویرایش اطلاعات"
              // onClick={() => navigate.navigate("/profile/edit", { props: { navigate: navigate } })}
            >
              <Icon slot="media" icon="mdi-pencil"></Icon>
            </ListItem>
            <ListItem
              href="/orders"
              title="سفارشات من"
            // onClick={this.orders}
            >
              <Icon slot="media" icon="mdi-format-list-bulleted"></Icon>
            </ListItem>
            <ListItem
              href="/addresses"
              title="آدرس‌های من"
            // onClick={this.addresses}
            >
              <Icon slot="media" icon="mdi-home-map-marker"></Icon>
            </ListItem>
            <ListItem
              href="/share"
              title="معرفی به دوستان"
            // onClick={this.share}
            >
              <Icon slot="media" icon="mdi-account-multiple-outline"></Icon>
            </ListItem>
            <ListItem
              href="#"
              title="خروج از حساب کاربری"
              onClick={this.signOut}
            >
              <Icon slot="media" icon="mdi-exit-to-app"></Icon>
            </ListItem>
          </List>
        </CardContent>
      </GroupBox>
    )
  }
}

export default connect(
  state => ({
    user: state.General.user
  }),
  {
    logout,
    getCart
  }
)(withLocale('view_profile')(autobind(ViewProfile)))
